
import WebService from "../../WebService"

const VideoEvent = {
    gets(params) {
        return WebService.get("/console/contest/video-event?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/video-event/" + id + '?e=' + e)
    },
    update(data) {
        return WebService.post("/console/contest/video-event/" + data.event_id, data)
    },
}
export default VideoEvent
